var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 1.25C6.22386 1.25 6 1.02614 6 0.75C6 0.473858 6.22386 0.25 6.5 0.25H11C11.2761 0.25 11.5 0.473858 11.5 0.75V5.75C11.5 6.02614 11.2761 6.25 11 6.25C10.7239 6.25 10.5 6.02614 10.5 5.75V1.95711L3.35355 9.10355C3.15829 9.29882 2.84171 9.29882 2.64645 9.10355C2.45118 8.90829 2.45118 8.59171 2.64645 8.39645L9.79289 1.25H6.5ZM2.5 3.25C1.67157 3.25 1 3.92157 1 4.75V9.25C1 10.0784 1.67157 10.75 2.5 10.75H7.5C8.32843 10.75 9 10.0784 9 9.25V7.25C9 6.97386 9.22386 6.75 9.5 6.75C9.77614 6.75 10 6.97386 10 7.25V9.25C10 10.6307 8.88071 11.75 7.5 11.75H2.5C1.11929 11.75 0 10.6307 0 9.25V4.75C0 3.36929 1.11929 2.25 2.5 2.25H4.5C4.77614 2.25 5 2.47386 5 2.75C5 3.02614 4.77614 3.25 4.5 3.25H2.5Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.33eb363c92ad10392d5a747824f34e15.svg";
export { ForwardRef as ReactComponent };